import CIMSFormItem from 'components/CIMSFormItem'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { HelpMessage } from 'utils/constants'
import { useDispositionTypesContext } from '../../DispositionTypesContext'

const CreateEditFormItems: React.VFC = () => {
  const { types, loading } = useDispositionTypesContext()
  return (
    <>
      <NameFormItem help={HelpMessage.Name} />
      <DescriptionFormItem entityName="Type" />
      <CIMSFormItem
        name="nonApplicableTypes"
        label="Non-Applicable Disposition Types"
        help={HelpMessage.Issues.DispositionTypes.NonApplicableIssueTypes}
      >
        <CIMSSelect mode="multiple" options={types} loading={loading} />
      </CIMSFormItem>
    </>
  )
}

export default CreateEditFormItems
